const FACEOFF = 502;
const HIT = 503;
const GIVEAWAY = 504;
const GOAL = 505;
const SHOT_ON_GOAL = 506;
const MISSED_SHOT = 507;
const BLOCKED_SHOT = 508;
const PENALTY = 509;
const STOPPAGE = 516;
const SUBSTITUTION = 517;
const GAME_SCHEDULED = 518;
const PERIOD_READY = 519;
const PERIOD_START = 520;
const PERIOD_END = 521;
const PERIOD_OFF = 522;
const SHOOTOUT_COMPLETE = 523;
const GAME_END = 524;
const TAKEAWAY = 525;
const EARLY_INTERMISSION_START = 526;
const EARLY_INTERMISSION_END = 527;
const GAME_OFFICIAL = 528;
const EMERGENCY_GOALTENDER_PLAYER_ID_CHANGE = 529;
const CHALLENGE = 530;

export default {
    FACEOFF,
    HIT,
    GIVEAWAY,
    GOAL,
    SHOT_ON_GOAL,
    MISSED_SHOT,
    BLOCKED_SHOT,
    PENALTY,
    STOPPAGE,
    SUBSTITUTION,
    GAME_SCHEDULED,
    PERIOD_READY,
    PERIOD_START,
    PERIOD_END,
    PERIOD_OFF,
    SHOOTOUT_COMPLETE,
    GAME_END,
    TAKEAWAY,
    EARLY_INTERMISSION_START,
    EARLY_INTERMISSION_END,
    GAME_OFFICIAL,
    EMERGENCY_GOALTENDER_PLAYER_ID_CHANGE,
    CHALLENGE
};